export default __webpack_public_path__ + "static/media/google-logo.46987544.svg";